import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Policy } from '../policy.model';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  selectedPlan:string='';
  setSelectedPlan(plan){
    this.selectedPlan=plan;
    localStorage.setItem('pid', this.selectedPlan);
  }

  adminSub: Subject<boolean>= new Subject<boolean>();
  adminObs = this.adminSub.asObservable();


  constructor(public db: AngularFirestore) {}

  adminIn:boolean=false;

  adminLin(){
    this.adminIn=true;
  }
  adminLout(){
    this.adminIn=false;
  }

  getImages(){
      return this.db.collection('/images').valueChanges();
  }

  getPlan(planKey){
    return this.db.collection('plans').doc(planKey).snapshotChanges();
  }

  updatePlan(planKey, value){
    return this.db.collection('plans').doc(planKey).set(value);
  }

  addMessage(value){
    return this.db.collection('messages').add({
      email: value.uname,
      phn: value.phn,
      message: value.message
    });
  }
  getMessages(){
    return this.db.collection('messages').snapshotChanges();
  }

  deletePlan(planKey){
    return this.db.collection('plans').doc(planKey).delete();
  }
  deleteUser(key){
    return this.db.collection('users').doc(key).delete();
  }

  getPlans(){
    return this.db.collection('plans').snapshotChanges();
  }
  getUsers(){
    return this.db.collection('users').snapshotChanges();
  }

  newOrder(uid, pid, total, payid){
    return this.db.collection('orders').add({
      uid:uid,
      pid:pid,
      total:total,
      payid:payid
    });
  }
  getOrders(){
    return this.db.collection('orders').snapshotChanges();
  }
  deleteOrder(key){
    return this.db.collection('orders').doc(key).delete();
  }

  userOrders(searchValue){
    return this.db.collection('orders',ref => ref.where('uid', '==', searchValue)).snapshotChanges();
  }


  searchPlansByAge(value){
    return this.db.collection('plans',ref => ref.orderBy('age').startAt(value)).snapshotChanges();
  }

  createPlan(value){
    return this.db.collection('plans').add({
      pname: value.pname,
      price: value.price,
      category: value.category,
      speed: value.speed,
      data: value.data,
      exspeed: value.exspeed
    });
  }
}

//copy of previous working code

// import { Injectable } from '@angular/core';
// import { AngularFirestore } from '@angular/fire/firestore';
// import { Policy } from '../policy.model';

// @Injectable({
//   providedIn: 'root'
// })
// export class FirebaseService {

//   constructor(public db: AngularFirestore) {}

//   getImages(){
//       return this.db.collection('/images').valueChanges();
//   }

//   getPlan(planKey){
//     return this.db.collection('plans').doc(planKey).snapshotChanges();
//   }

//   updatePlan(planKey, value){
//     value.nameToSearch = value.name.toLowerCase();
//     return this.db.collection('plans').doc(planKey).set(value);
//   }

//   deletePlan(planKey){
//     return this.db.collection('plans').doc(planKey).delete();
//   }

//   getPlans(){
//     return this.db.collection('plans').snapshotChanges();
//   }

//   searchPlans(searchValue){
//     return this.db.collection('plans',ref => ref.where('nameToSearch', '>=', searchValue)
//       .where('nameToSearch', '<=', searchValue + '\uf8ff'))
//       .snapshotChanges()
//   }

//   searchPlansByAge(value){
//     return this.db.collection('plans',ref => ref.orderBy('age').startAt(value)).snapshotChanges();
//   }

//   createItem(value){
//     return this.db.collection('items').add({
//       content: value
//     });
//   }
//   createPlan(value, id:string, url:string){
//     return this.db.collection('plans').add({
//       pname: value.pname,
//       price: value.price,
//       category: value.category,
//       id: id,
//       imgurl:url
//     });
//   }
// }
